import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FunctionComponent } from "react";
import { Theme } from "@emotion/react";
import { Button } from "@mui/material";
import { media, styled } from "@iventis/styles";

interface SidebarToggleProps {
    showSidebar: boolean;
    scheduleName: string;
    scheduleColour: string;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
}

/**
 * A component used in the schedule which is two different buttons to toggle the sidebar to show and hide
 * @param {boolean} showSidebar - if sidebar is showing or not
 * @param {string} scheduleName - name of the schedule
 * @param {string} scheduleColour - colour of the schedule icon
 * @param {() => void} onClick - handles on click function
 */
const SideBarToggleComponent: FunctionComponent<SidebarToggleProps> = ({ showSidebar, scheduleName, scheduleColour, onClick, disabled, className }) => (
    <>
        {/* Sidebar is not showing */}
        {!showSidebar && (
            <ScheduleButton data-cy="sidebar-toggle" color="inherit" variant="outlined" onClick={onClick} disabled={disabled} className={className}>
                <ScheduleNameAndIcon>
                    <FontAwesomeIcon className="schedule-icon" size="sm" icon={["fas", "circle"]} color={scheduleColour} />
                    <span className="name">{scheduleName}</span>
                </ScheduleNameAndIcon>
                <FontAwesomeIcon size="sm" icon={["fas", "list-ul"]} />
            </ScheduleButton>
        )}

        {/* Side bar is showing */}
        {showSidebar && (
            <CollapseButton data-cy="sidebar-toggle" color="inherit" variant="outlined" onClick={onClick}>
                <FontAwesomeIcon style={{ height: "18px" }} icon={["far", "chevrons-left"]} />
            </CollapseButton>
        )}
    </>
);

const ScheduleNameAndIcon = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
    margin-right: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 600;
    .schedule-icon {
        margin-right: 10px;
    }
`;

const ScheduleButton = styled(Button)`
    max-width: 468px;
    border: 1px solid ${({ theme }: { theme: Theme }) => theme.primaryColors.altFocusBorder};
    color: ${({ theme }: { theme: Theme }) => theme.primaryColors.altFocusText};
    height: 44px;
    padding: 0px 15px;
    margin-right: 0px;
`;

const CollapseButton = styled(ScheduleButton)`
    max-width: 44px;
    min-width: 44px;
    margin-left: -10px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    background-color: #dcddf9;
    border: 1px solid transparent;
    border-left-width: 0px;
    display: none;
    :hover {
        background-color: #dcddf9;
        border: ${({ theme }: { theme: Theme }) => `1px solid ${theme.shades.two}`};
        border-left-width: 0px;
    }
    ${media.small} {
        display: inline-flex;
    }
`;

export default SideBarToggleComponent;
